<ng-container *ngIf="isShown">
  <div class="h-full w-full bg-white/75 absolute flex align-items-center z-10 cursor-not-allowed">
    <div class="block mx-auto">
      <div class="loading">
        <div *ngFor="let i of [].constructor(9)"></div>
      </div>
    </div>
  </div>
</ng-container>